import { render, staticRenderFns } from "./BaseComposeEmailDialog.vue?vue&type=template&id=ff048974&scoped=true&"
import script from "./BaseComposeEmailDialog.vue?vue&type=script&lang=js&"
export * from "./BaseComposeEmailDialog.vue?vue&type=script&lang=js&"
import style0 from "./BaseComposeEmailDialog.vue?vue&type=style&index=0&id=ff048974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff048974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff048974')) {
      api.createRecord('ff048974', component.options)
    } else {
      api.reload('ff048974', component.options)
    }
    module.hot.accept("./BaseComposeEmailDialog.vue?vue&type=template&id=ff048974&scoped=true&", function () {
      api.rerender('ff048974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseComposeEmailDialog.vue"
export default component.exports